import CustomLink from "./CustomLink";
import { ProjectItem } from "./ProjectList";
import styles from "./ProjectNav.module.css";

export default function ProjectQuickNav({ prevProject, nextProject }) {
  return (
    <div className={styles.ProjectNav}>
      <div className={styles.links}>
        <CustomLink href={prevProject.url} className={styles.link}>
          Previous
        </CustomLink>
        <CustomLink href={nextProject.url} className={styles.link}>
          Next
        </CustomLink>
      </div>
      <ul className={styles.items}>
        <ProjectItem projectPage={prevProject} />
        <ProjectItem projectPage={nextProject} />
      </ul>
    </div>
  );
}
